var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.1 91.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6,0C20.4,0,0,20.4,0,45.6s20.4,45.6,45.6,45.6s45.6-20.4,45.6-45.6C91.1,20.4,70.7,0,45.6,0z M45.6,81.2 c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2S50.1,81.2,45.6,81.2z M53.8,49.9c0,4.5-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2 V19c0-4.5,3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2V49.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleIcon);
export default __webpack_public_path__ + "static/media/alert-circle-icon.f801812c5f35f408b95511b38560b6dd.svg";
export { ForwardRef as ReactComponent };